import { CareerSkillDetailQuery } from 'core';

import { ISkillProvider } from './transformSkillMap';

export interface ISkillProfession {
  code: string;
  title: string;
  summary: string;
  /** Сколько навыков этой профессии у меня уже есть — и сколько всего. */
  haveCount: number;
  totalCount: number;
}

export interface ISkillDetail {
  id: string;
  name: string;
  slug: string;
  category: string;
  description: string;
  iconUrl: string | null;
  /** `null` — навыка у меня нет; тогда страница показывает «где взять». */
  myLevel: number | null;
  /** 'course' — подтверждено школой, 'self' — заявлено самим. */
  mySource: string | null;
  grantedCourseName: string | null;
  /** ТЗ 0040: занятие, на котором навык открылся. */
  grantedLessonNumber: number | null;
  liveVacancies: number | null;
  demandBand: number;
  providers: ISkillProvider[];
  professions: ISkillProfession[];
}

export const transformSkillDetail = (
  data: CareerSkillDetailQuery | undefined,
): ISkillDetail | null => {
  const node = data?.careerSkillDetail;
  if (!node) return null;

  return {
    id: node.skill.id,
    name: node.skill.name,
    slug: node.skill.slug,
    category: node.skill.category,
    description: node.skill.description ?? '',
    iconUrl: node.skill.iconUrl ?? null,
    myLevel: node.myLevel ?? null,
    mySource: node.mySource ?? null,
    grantedCourseName: node.grantedCourseName ?? null,
    grantedLessonNumber: node.grantedLessonNumber ?? null,
    // `null` и ноль — разные вещи: снимок мог не считаться вовсе.
    liveVacancies: node.demand ? node.demand.liveVacancies : null,
    demandBand: node.demand?.band ?? 0,
    providers: node.providers.map((row) => ({
      courseId: row.courseId,
      courseName: row.courseName,
      courseUrl: row.courseUrl,
      level: row.level,
      completed: row.completed,
    })),
    professions: node.professions.map((row) => ({
      code: row.code,
      title: row.title,
      summary: row.summary,
      haveCount: row.haveCount,
      totalCount: row.totalCount,
    })),
  };
};
